module.exports = __webpack_public_path__ + "static/media/labby.ab516af3.png";